var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCarrotUp = function SvgCarrotUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.593 15.385a1.05 1.05 0 01-1.485 0l-4.158-4.158-4.158 4.158A1.05 1.05 0 116.308 13.9l4.9-4.9a1.05 1.05 0 011.485 0l4.9 4.9c.41.41.41 1.075 0 1.485z",
    fill: "#9CA6AD"
  })));
};

export default SvgCarrotUp;